import { NewAddress } from '@/components/forms'
import { useRequireAuth } from '@/hooks/use-require-auth'

export default function NewProfileAddressPage() {
  useRequireAuth()

  return <NewAddress redirectTo="/profile/addresses" text="Como você gostaria de cadastrar seu endereço?" />
}
